export const PRESET_COLORS = [null, '#c25e5e', '#e89055', '#d4b97a', '#6db580', '#7aaee0'] as const;
